import { z } from "zod/v4";
import { paymentDashboardResponseSchema, paymentResponseSchema } from "../../schemas/finance";
import { fetchApi } from "../client/internal";

const paginatedPayments = z.object({
	items: z.array(paymentResponseSchema),
	total: z.number(),
	limit: z.number(),
	offset: z.number(),
});

export const payments = {
	list: (clubId: string) => fetchApi(`/${clubId}/payments`, paginatedPayments),
	dashboard: (clubId: string) =>
		fetchApi(`/${clubId}/payments/dashboard`, paymentDashboardResponseSchema),
};
